import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { format } from "date-fns";
import { useAppointments } from "../../../hooks/useAppointments";

function AppointmentDetail() {
    const { id } = useParams();
    const { fetchCustomerAppointment, customerAppointments } = useAppointments();
    
    useEffect(() => {
        fetchCustomerAppointment(id);
    }, [id]);

    if (!customerAppointments || !customerAppointments.appointment) {
        return <div className="pageContainer">Lade Termindaten...</div>;
    }
    
    return (
        <div className="pageContainer">
            <h1>
                Termin mit {customerAppointments.appointment.customer.prename} {customerAppointments.appointment.customer.name} am{" "}
                {customerAppointments.appointment.date
                    ? format(new Date(customerAppointments.appointment.date), "dd.MM.yyyy HH:mm")
                    : ""}
            </h1>
            <div>
                <h2>Todos</h2>
            </div>
        </div>
    );
}

export default AppointmentDetail;